import { Flex, Text, Select } from '@scale/scaleui-radix';
import type { HubstaffMemberAction } from '@scale/genai-compass-shared/cards/hubstaff_member_actions';

interface ActionSelectorProps {
  action: HubstaffMemberAction | undefined;
  onChange: (action: HubstaffMemberAction) => void;
}

export default function ActionSelector({ action, onChange }: ActionSelectorProps) {
  return (
    <Flex direction="column" gap="2">
      <Text size="2" weight="bold">
        Step 2: Select an action <span style={{ color: 'red' }}>*</span>
      </Text>
      <Text size="1" color="gray">
        1. Add Members: adds users to the project (default role: User)
        <br />
        2. Change Role: changes members' role in this project
        <br />
        3. Change Time Tracking: enables/disables time tracking for members
        <br />
        4. Set Work Limits: sets daily and weekly work hour limits
        <br />
        5. Remove Members: removes users from the project
      </Text>
      <Select.Root value={action} onValueChange={value => onChange(value as HubstaffMemberAction)}>
        <Select.Trigger placeholder="Select an action" />
        <Select.Content>
          <Select.Item value="Add Members">Add Members</Select.Item>
          <Select.Item value="Change Role">Change Role</Select.Item>
          <Select.Item value="Change Time Tracking">Change Time Tracking</Select.Item>
          <Select.Item value="Set Work Limits">Set Work Limits</Select.Item>
          <Select.Item value="Remove Members">Remove Members</Select.Item>
        </Select.Content>
      </Select.Root>
    </Flex>
  );
}
